<template>
<div class="rights_box no-trans" v-loading="loading">
    <div class="r_top">
        <!-- <img src="@/assets/img/index/legal/r_top_bg.png" alt="" class="imgs"> -->
        <div class="titles">律师在线解答</div>
        <div class="text1">平均每5-10分钟获得律师快速解答</div>
        <div class="nums">123123123</div>
        <div class="text2">位用户已咨询</div>
        <div class="btns_box">
            <div class="btns" @click="$router.push('/lawyer_list')">快速咨询</div>
        </div>
    </div>
    <div class="new_lists">
        <div class="new_item" v-for="(item,index) in vuex_case_list" :key="index" v-if="index<2" @click="$router.push('/case_detial?id='+item.id)">
            <div class="new_title">
                <!-- 取保候审后还会被传唤吗？ -->
                 {{ item.title }}
            </div>
            <div class="new_texts">
                {{ item.desc }}
            </div>
            <div class="info_flex">
                <div class="img_text">
                    <img src="../../assets/img/index/comments_case/see.png" alt="">
                    {{ item.view_num }}
                </div>
                <div class="img_text">
                    <img src="../../assets/img/index/comments_case/pl_num.png" alt="">
                    {{ item.comment_num }}
                </div>
                <div class="img_text">
                    <img src="../../assets/img/index/comments_case/time.png" alt="">
                    {{ item.created_at }}
                </div>
            </div>
        </div>
    </div>
    <div class="r_bom" v-if="!mobile_view || $store.state.vuex_lawyers.length"
        @click.capture="guard_swipe_click">
        <div class="banner_title">推荐律师</div>

        <div class="change_box">
            <div class="change_item" :class="{ 'change_item_ac': banner_ac == index }"
                v-for="(item, index) in  $store.state.vuex_lawyers" :key="index"
                :role="mobile_view ? 'button' : null" :tabindex="mobile_view ? 0 : null"
                :aria-label="'查看第' + (index + 1) + '位律师'"
                @click="select_lawyer(index)" @keydown.enter.prevent="select_lawyer(index)"
                @keydown.space.prevent="select_lawyer(index)"></div>
        </div>
        <el-carousel ref="lawyer_carousel" :autoplay="true" :indicator-position="'none'" @change="change_banner"
            @touchstart.native.passive="lawyer_touch_start" @touchend.native.passive="lawyer_touch_end"
            @touchcancel.native.passive="lawyer_touch = null">
            <el-carousel-item v-for="(item, index) in  $store.state.vuex_lawyers" :key="index">
                <div class="banner_box">
                    <div class="borders_box">
                        <div class="borders1"></div>
                        <div class="borders2">
                            <img :src="item.business_img" alt="">

                        </div>
                        <div class="tage_box" v-if="item.elite==1">
                            <div class="tages">金牌律师</div>
                        </div>
                    </div>
                    <div class="ls_name">{{item.name}}律师</div>
                    <div class="ls_texts">{{minx_get_causeIds(item.causeIds)}}</div>
                    <div class="btns_flex">
                        <div class="btns" @click="$router.push('/lawyer_detial?id='+item.id)">
                            <img src="@/assets/img/index/legal/icons1.png" alt="">

                            快速咨询
                        </div>
                    </div>
                </div>
            </el-carousel-item>
        </el-carousel>
    </div>
</div>
</template>
<script>
import {
    mapState
} from 'vuex'



export default {
    components: {

    },
    name: "homes",
    data() {
        return {
            loading: false,
            banner_ac: 0,
            lawyer_touch: null,
            swipe_click_until: 0,

        }
    },
    computed: {
        
        ...mapState(['vuex_case_list','vuex_lawyers'])

    },
    watch: {

    },
    created() {

    },
    methods: {
        lawyer_touch_start(event) {
            this.lawyer_touch = null
            this.swipe_click_until = 0
            if (!this.mobile_view || event.touches.length !== 1) return
            this.lawyer_touch = { x: event.touches[0].clientX, y: event.touches[0].clientY }
        },
        lawyer_touch_end(event) {
            const start = this.lawyer_touch
            this.lawyer_touch = null
            if (!this.mobile_view || !start || !event.changedTouches.length) return
            const dx = event.changedTouches[0].clientX - start.x
            const dy = event.changedTouches[0].clientY - start.y
            if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.5) {
                this.swipe_click_until = Date.now() + 500
                this.$refs.lawyer_carousel[dx < 0 ? 'next' : 'prev']()
            }
        },
        guard_swipe_click(event) {
            if (this.mobile_view && Date.now() < this.swipe_click_until) {
                event.preventDefault()
                event.stopPropagation()
            }
        },
        select_lawyer(index) {
            if (this.mobile_view) this.$refs.lawyer_carousel.setActiveItem(index)
        },
        change_banner(e) {
            // console.log('却换触发',e)
            this.banner_ac = e
        },
    },

}
</script>
<style scoped lang="less">
.rights_box {
    width: 420px;
    min-height: 100px;

    // background-color: red;
    .r_top {
        width: 420px;
        height: 300px;
        position: relative;
        padding: 32px 36px;
        // background-image: url("@/assets/img/index/legal/r_top_bg.png" );
        background-image: url('../../assets/img/index/legal/r_top_bg.png');
        background-size: 100%;

        // .imgs{
        //     width: 420px;
        //     height: 300px;
        //     position: absolute;
        //     left: 0;
        //     top: 0;
        // }
        .titles {
            font-family: Microsoft YaHei, Microsoft YaHei;
            font-weight: 400;
            font-size: 24px;
            color: #333333;

        }

        .text1 {
            padding-top: 14px;
            font-family: Microsoft YaHei, Microsoft YaHei;
            font-weight: 400;
            font-size: 14px;
            color: #666666;

        }

        .nums {
            padding-top: 20px;
            font-family: Microsoft YaHei, Microsoft YaHei;
            font-weight: bold;
            font-size: 36px;
            color: #377CFD;

        }

        .text2 {

            font-family: Microsoft YaHei, Microsoft YaHei;
            font-weight: 400;
            font-size: 14px;
            color: #666666;

        }

        .btns_box {
            padding-top: 40px;

            .btns {
                width: 180px;
                height: 40px;
                background: #377CFD;
                box-shadow: 0px 3px 6px 1px rgba(0, 0, 0, 0.16);
                border-radius: 4px 4px 4px 4px;
                text-align: center;
                line-height: 40px;
                cursor: pointer;
                font-family: Microsoft YaHei, Microsoft YaHei;
                font-weight: bold;
                font-size: 14px;
                color: #FFFFFF;
            }
        }
    }
    .new_lists{
        padding-top: 24px;
        .new_item{
            width: 416px;
            height: 217px;
            background: #FFFFFF;
            border-radius: 0px 0px 0px 0px;
            margin-bottom: 24px;
            padding:20px 24px;
            cursor: pointer;
            .new_title{
                font-family: Microsoft YaHei, Microsoft YaHei;
                font-weight: bold;
                font-size: 20px;
                color: #333333;
            }
            .new_texts{
                padding-top: 16px;
                font-weight: 400;
                font-size: 14px;
                color: #666666;
                padding-bottom: 24px;
                border-bottom: 1px solid #D7D7D7;

            }
            .info_flex{
                display: flex;
                align-items: center;
                padding-top: 20px;
                .img_text{
                    display: flex;
                    align-items: center;
                    font-family: Microsoft YaHei, Microsoft YaHei;
                    font-weight: 400;
                    font-size: 14px;
                    color: #999999;
                    margin-right: 20px;
                    img{
                        height: 15px;
                        margin-right: 7px;
                    }
                }
            }
        }
    }

    .r_bom {
        width: 420px;
        height: 460px;
        // background: red;
        margin-top: 24px;
        position: relative;

        .banner_title {
            position: absolute;
            top: 24px;
            left: 32px;
            display: flex;
            align-items: center;
            z-index: 100;
            font-weight: bold;
            font-size: 18px;
            color: #FFFFFF;
        }

        .change_box {
            position: absolute;
            top: 32px;
            right: 32px;
            display: flex;
            align-items: center;
            z-index: 100;

            .change_item {
                width: 6px;
                height: 6px;
                background: #F2F2F5;
                border-radius: 50%;
                margin-left: 6px;
            }

            .change_item_ac {
                background: #377CFD;
            }
        }

        /deep/.el-carousel {
            width: 100%;
            height: 100%;

            .el-carousel__container {
                width: 100%;
                height: 100%;

                .banner_box {
                    width: 100%;
                    height: 100%;
                    background-image: url('../../assets/img/index/legal/banner_bg.png');
                    background-size: 100%;
                    padding-top: 88px;

                    .borders_box {
                        width: 160px;
                        height: 160px;
                        margin: auto;
                        border-radius: 50%;
                        // margin-top: 88px; 
                        // background: #FFFFFF;
                        // opacity: 0.2;
                        position: relative;

                        .borders1 {
                            width: 160px;
                            height: 160px;
                            background: #FFFFFF;
                            opacity: 0.2;
                            position: absolute;
                            left: 0;
                            top: 0;
                            z-index: 1;
                            border-radius: 50%;

                        }

                        .borders2 {
                            width: 132px;
                            height: 132px;
                            background: #C4C4C4;
                            position: absolute;
                            left: 50%;
                            top: 50%;
                            z-index: 2;
                            border-radius: 50%;

                            transform: translate(-50%, -50%);

                            img {
                                width: 132px;
                                height: 132px;
                                border-radius: 50%;

                            }
                        }

                        .tage_box {
                            width: 100%;
                            position: absolute;
                            z-index: 3;
                            bottom: -4px;
                            display: flex;
                            align-items: center;
                            justify-content: center;

                            .tages {
                                cursor: pointer;
                                width: 104px;
                                height: 32px;
                                background: linear-gradient(180deg, #FAECC6 0%, #F2CF85 100%);
                                border-radius: 16px 16px 16px 16px;
                                border: 1px solid #876052;
                                font-family: Microsoft YaHei, Microsoft YaHei;
                                font-weight: 400;
                                font-size: 14px;
                                color: #6C3E2D;
                                text-align: center;
                                line-height: 32px;
                            }
                        }

                    }

                    .ls_name {
                        padding-top: 28px;
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: 400;
                        font-size: 24px;
                        color: #FFFFFF;
                        text-align: center;
                    }

                    .ls_texts {
                        padding-top: 14px;
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: 400;
                        font-size: 14px;
                        color: #FFFFFF;
                        text-align: center;
                    }

                    .btns_flex {
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        padding-top: 40px;

                        .btns {
                            width: 180px;
                            height: 40px;
                            background: #377CFD;
                            box-shadow: 0px 3px 6px 1px rgba(0, 0, 0, 0.16);
                            border-radius: 4px 4px 4px 4px;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            line-height: 40px;
                            text-align: center;
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: bold;
                            font-size: 14px;
                            color: #FFFFFF;
                            cursor: pointer;

                            img {
                                width: 14px;
                                height: 14px;
                                margin-right: 10px;
                            }
                        }
                    }
                }
            }

            .el-carousel__indicators {
                //  display: none;
            }
        }
    }
}
</style>
<style scoped lang="less">
@import "../../styles/mobile-patterns.less";

@media (max-width: 1024px) {
    .rights_box.no-trans {
        max-width: 100%;
        min-width: 0;
        font-size: 14px;
        line-height: 1.6;
        width: 100%;
    }
    .rights_box.no-trans .r_top {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        min-height: 0;
        height: auto;
        padding: 16px 16px;
    }
    .rights_box.no-trans .r_top .titles {
        font-size: 24px;
    }
    .rights_box.no-trans .r_top .text1 {
        padding-top: 14px;
        font-size: 14px;
    }
    .rights_box.no-trans .r_top .nums {
        padding-top: 16px;
        font-size: 24px;
    }
    .rights_box.no-trans .r_top .text2 {
        font-size: 14px;
    }
    .rights_box.no-trans .r_top .btns_box {
        padding-top: 16px;
    }
    .rights_box.no-trans .r_top .btns_box .btns {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        height: auto;
        border-radius: 4px 4px 4px 4px;
        line-height: 1.6;
        font-size: 14px;
        min-height: 44px;
        padding-top: 12px;
        padding-bottom: 12px;
    }
    .rights_box.no-trans .new_lists {
        padding-top: 16px;
    }
    .rights_box.no-trans .new_lists .new_item {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        min-height: 0;
        height: auto;
        border-radius: 0px 0px 0px 0px;
        margin-bottom: 16px;
        padding: 16px 16px;
    }
    .rights_box.no-trans .new_lists .new_item .new_title {
        font-size: 20px;
    }
    .rights_box.no-trans .new_lists .new_item .new_texts {
        padding-top: 16px;
        font-size: 14px;
        padding-bottom: 16px;
    }
    .rights_box.no-trans .new_lists .new_item .info_flex {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        padding-top: 16px;
    }
    .rights_box.no-trans .new_lists .new_item .info_flex .img_text {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        font-size: 14px;
        margin-right: 16px;
    }
    .rights_box.no-trans .new_lists .new_item .info_flex .img_text img {
        height: 15px;
        margin-right: 7px;
    }
    .rights_box.no-trans .r_bom {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        min-height: 0;
        height: auto;
        margin-top: 16px;
    }
    .rights_box.no-trans .r_bom .banner_title {
        top: 16px;
        left: 16px;
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        font-size: 18px;
    }
    .rights_box.no-trans .r_bom .change_box {
        top: 16px;
        right: 16px;
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
    }
    .rights_box.no-trans .r_bom .change_box .change_item {
        width: 6px;
        height: 6px;
        border-radius: 50%;
        margin-left: 6px;
    }
    .rights_box.no-trans .r_bom /deep/ .el-carousel .el-carousel__container .banner_box {
        padding-top: 16px;
    }
    .rights_box.no-trans .r_bom /deep/ .el-carousel .el-carousel__container .banner_box .borders_box {
        width: 160px;
        height: 160px;
        margin: auto;
        border-radius: 50%;
    }
    .rights_box.no-trans .r_bom /deep/ .el-carousel .el-carousel__container .banner_box .borders_box .borders1 {
        width: 160px;
        height: 160px;
        border-radius: 50%;
    }
    .rights_box.no-trans .r_bom /deep/ .el-carousel .el-carousel__container .banner_box .borders_box .borders2 {
        width: 132px;
        height: 132px;
        border-radius: 50%;
    }
    .rights_box.no-trans .r_bom /deep/ .el-carousel .el-carousel__container .banner_box .borders_box .borders2 img {
        width: 132px;
        height: 132px;
        border-radius: 50%;
    }
    .rights_box.no-trans .r_bom /deep/ .el-carousel .el-carousel__container .banner_box .borders_box .tage_box {
        bottom: -4px;
    }
    .rights_box.no-trans .r_bom /deep/ .el-carousel .el-carousel__container .banner_box .borders_box .tage_box .tages {
        width: 104px;
        height: 32px;
        border-radius: 8px 8px 8px 8px;
        font-size: 14px;
        line-height: 32px;
    }
    .rights_box.no-trans .r_bom /deep/ .el-carousel .el-carousel__container .banner_box .ls_name {
        padding-top: 16px;
        font-size: 24px;
    }
    .rights_box.no-trans .r_bom /deep/ .el-carousel .el-carousel__container .banner_box .ls_texts {
        padding-top: 14px;
        font-size: 14px;
    }
    .rights_box.no-trans .r_bom /deep/ .el-carousel .el-carousel__container .banner_box .btns_flex {
        padding-top: 16px;
    }
    .rights_box.no-trans .r_bom /deep/ .el-carousel .el-carousel__container .banner_box .btns_flex .btns {
        width: 180px;
        height: auto;
        border-radius: 4px 4px 4px 4px;
        line-height: 1.6;
        font-size: 14px;
        min-height: 44px;
        padding-top: 12px;
        padding-bottom: 12px;
    }
    .rights_box.no-trans .r_bom /deep/ .el-carousel .el-carousel__container .banner_box .btns_flex .btns img {
        width: 14px;
        height: 14px;
        margin-right: 10px;
    }
}

@media (max-width: 1024px) {
    .rights_box.no-trans .r_bom { .mobile-lawyer-recommendation(); }
}
</style>
